export default "__VITE_ASSET__CO9OjnIl__"